const UUID_REGEX = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;
export const UUID_REPLACEMENT = "<UUID>";

export const replaceUuid = (source: string) => source.replaceAll(UUID_REGEX, UUID_REPLACEMENT);
